import React from 'react'

import { Typography } from '@telavita-core/react-design-kit'
import { MedicalRequestForm } from 'components/MedicalRequestForm'
import { RootStateOrAny, useSelector } from 'react-redux'
import ModalGeneric from '../ModalGeneric'
import { MedicalRequestSuccessModal } from './components/MedicalRequestSuccessModal'
import * as S from './styles'

interface MedicalRequestModalProps {
  onClose: () => void;
  onSuccess?: () => void;
  planCode: string;
}

export const MedicalRequestModal: React.FC<MedicalRequestModalProps> = ({
  onClose,
  onSuccess,
  planCode,
}) => {
  const [openSuccessModal, setOpenSuccessModal] = React.useState(false)
  const [errorMessage, setErrorMessage] = React.useState<string | null>(null)

  const planSelected = useSelector((state: RootStateOrAny) =>
    state?.auth?.profileSelected?.plans?.find(
      (plan) => plan.partner_plan_code === planCode
    )
  )
  const userPlanGroup = planSelected?.plan_group

  const handleSuccess = () => {
    onSuccess && onSuccess()
    setOpenSuccessModal(true)
  }

  const handleError = () => {
    setErrorMessage(
      'Não foi possível enviar seu pedido médico. Verifique as informações preenchidas e tente novamente.'
    )
  }

  return (
    <>
      {openSuccessModal && (
        <MedicalRequestSuccessModal
          onClose={() => setOpenSuccessModal(false)}
        />
      )}
      <ModalGeneric
        modalTitle="Nova solicitação de consultas ao convênio"
        type="medium"
        onCloseModal={onClose}
        btnOnClick={onClose}
      >
        <S.ContentSection>
          <S.MedicalRequestFormContainer>
            <S.Description>
              <Typography>
                Certifique-se de inserir os dados corretamente ou anexe um novo
                pedido médico.
              </Typography>
            </S.Description>
            <S.LogoWrapper>
              <img
                src={userPlanGroup?.logo_url ?? ''}
                alt={userPlanGroup?.name ?? ''}
                width={115}
                height={62}
              />
            </S.LogoWrapper>
            <MedicalRequestForm
              onSuccess={handleSuccess}
              planCode={planCode}
              onError={handleError}
            />
            <S.ErrorMessageContent>
              {errorMessage && (
                <Typography color="danger" variant="content3">
                  {errorMessage}
                </Typography>
              )}
            </S.ErrorMessageContent>
          </S.MedicalRequestFormContainer>
        </S.ContentSection>
      </ModalGeneric>
    </>
  )
}
